import { Divider, type DividerProps } from "ui/divider/divider";
import { mergeSx } from "ui/merge-sx";

import { DIVIDER_SX } from "ui/actions-menu/actions-menu.styles";

export const ActionMenuDivider = ({ sx, ...rest }: DividerProps) => (
  <Divider {...rest} sx={mergeSx(DIVIDER_SX, sx)} />
);
